import {
  bareLabelLiftPx,
  LABEL_MARKER_GAP_PX,
  locationHaloWidthPx,
  LOCATION_LABEL,
} from './labelLayerStyle'
import { PLAIN_LABEL_PLATE } from './labelPlateSpec'
import { MARKER_SPEC } from './markerGeometry'

// Where a location's label sits relative to its marker, and how much room its plate needs.
// Deterministic: the tier, the plate spec and the marker's diameter in, pixels out. It is the
// one piece of label geometry that has to know about the circle, which is why it lives beside
// both rather than inside either.

// The plate's breathing room, the same on both axes. The spec's 4px holds at the editor's
// default size and below; above that it grows with the font, or a large label reads tight.
export function getLabelPlatePadding(fontSize: number): number {
  return Math.max(PLAIN_LABEL_PLATE.padXPx, fontSize / 2 - 5)
}

// How far below the point an UNPLATED label's line box starts, so its CASING clears the circle
// by LABEL_MARKER_GAP_PX at any font size.
//
// A flat radius would put the line box ON the circle's edge, leaving only Inter's leading
// between text and circle — and that leading scales with the type, so the gap would too.
export function getLabelLiftPx(labelSize: number): number {
  return (
    MARKER_SPEC.outerSize / 2 +
    bareLabelLiftPx(LOCATION_LABEL, labelSize, locationHaloWidthPx(labelSize))
  )
}

// How far below the point a boxed label's TEXT starts, in pixels at full scale, so that the
// plate's OUTER edge — not the text — clears the circle by LABEL_MARKER_GAP_PX. Same gap, same
// reference edge, as the unplated lift above; only what counts as "the label's edge" differs.
//
// One value, no zoom band: every part above the text rides the label's own curve — the padding
// by being ramped one level ahead, the radius by being baked pre-divided by that same level —
// so a single em offset holds at every zoom. The plate has no stroke, so its outer edge is where
// the padding ends.
export function getBoxedLabelLiftPx(labelSize: number): number {
  return (
    MARKER_SPEC.outerSize / 2 +
    LABEL_MARKER_GAP_PX +
    getLabelPlatePadding(labelSize)
  )
}
